import { Box, Button, IconButton, styled, useTheme } from '@mui/material';

import { extractFileNameFromUrl } from '@/utils/helper';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

type CommonFileInputProps = {
  file: File | null;
  onFileChange: (file: File | null) => void;
  url?: string;
  accept?: string;
};

export const CommonFileInput = ({
  file,
  onFileChange,
  url,
  accept,
}: CommonFileInputProps) => {
  const theme = useTheme();

  const fileName = file?.name || extractFileNameFromUrl(url);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
      <Button
        sx={{
          background: 'transparent !important',
          border: `1px dashed`,
          borderColor: theme.palette.greyShades.grey1,
          flexGrow: 1,
        }}
        component="label"
      >
        {fileName || 'No file choosen'}
        <VisuallyHiddenInput
          type="file"
          accept={accept}
          onChange={(e) => onFileChange(e.target.files?.[0] || null)}
        />
      </Button>
      {url && (
        <IconButton href={url} target="_blank">
          <i className="fa-light fa-cloud-arrow-down" />
        </IconButton>
      )}
    </Box>
  );
};
